import React from 'react';
import moment from 'moment';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import LoadingSpinner from '@buyside/components/presentation/LoadingSpinner/loadingSpinner';
import RequestRow from '@buyside/components/presentation/UserAccount/ViewerIntroRequests/Row/userViewerIntroRequestRow';

import { useCurrentUserViewerIntroRequestsQuery } from '@interfaces/graphql-typings';

import styles from './styles.scss';

const UserViewerIntroRequestTable: React.FC = () => {
  const { data, loading, error, fetchMore } = useCurrentUserViewerIntroRequestsQuery();

  if (loading) return <LoadingSpinner />;

  const currentUser = data?.currentUser;

  if (!currentUser || !currentUser?.viewerIntroRequests) return null;

  const { edges: requests, pageInfo } = currentUser.viewerIntroRequests;

  if (!requests?.length)
    return <span>There are no intro requests that require your attention at this time.</span>;

  return (
    <table className={styles.container}>
      <thead>
        <tr>
          <th>Date Received</th>
          <th>Status</th>
          <th>Sender</th>
          <th>Report</th>
          <th colSpan={2}></th>
        </tr>
      </thead>
      <tbody>
        {error && (
          <tr>
            <td className={styles.error}>{error.message}</td>
          </tr>
        )}

        {requests?.map(edge => {
          const node = edge?.node;
          if (!node) return null;

          const { author, createdAt, id, status, viewableId, viewableDisplayTitle } = node;

          const dateReceived = moment(new Date(createdAt), 'YYYY-MM-DD').format('l');

          return (
            <RequestRow
              key={id}
              id={id}
              currentUserId={currentUser.id}
              dateReceived={dateReceived}
              authorId={author?.id}
              status={status}
              authorDisplayName={author?.displayName}
              viewableDisplayTitle={viewableDisplayTitle}
              viewableId={viewableId}
            />
          );
        })}
      </tbody>

      {pageInfo.hasNextPage && (
        <tfoot>
          <tr>
            <td colSpan={5}>
              <div className={styles.nav}>
                <Button
                  text="Show More"
                  type={BUTTON_TYPES.LINK}
                  onClick={(): void => {
                    fetchMore({ variables: { cursor: pageInfo.endCursor } });
                  }}
                />
              </div>
            </td>
          </tr>
        </tfoot>
      )}
    </table>
  );
};

export default UserViewerIntroRequestTable;
